const myStack = [
  "HTML5",
  "CSS3",
  "SASS",
  "BOOTSTRAP",
  "JAVASCRIPT (ES6)",
  "REACT JS",
  "NODE JS",
  "GULP",
  "NPM",
  "SQLITE",
  "EXPRESS JS",
  "VISUAL STUDIO CODE",
  "GIT",
  "GITHUB",
  "FIGMA",
  "ZEPLIN",
  "ILLUSTRATOR",
  "PHOTOSHOP",
  "AVID MEDIA COMPOSER",
];

export default myStack;
